
import React, { useEffect, useState } from 'react';
import S from './ListDam.module.css'
import D from '../images/statuss.svg'
import {  useSelector } from 'react-redux';
import Hoc from '../Components/HOCcattles/Hoc';
import useList from '../Components/CustomHooks/useList';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Box, Tab } from '@mui/material';
import History from '../Components/HOCcattles/History';
import StatusHistory from '../Components/HOCcattles/StatusHistory';
import { useLocation } from 'react-router-dom';


 function StatusPage() {
  const {search} = useLocation();
   const [value,setValue]=useState(search=='?fromDash'?'2':'1');
   const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className={S.AllAnimalssLICon}>
      <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} src={D}/>
        <h2>وضعیت ها</h2>
        </div>
        <div style={{display:'flex', gap:'10px',alignItems:'center'}}>
        
        
        
        </div>
           
      </div>
      <TabContext value={value}>
  <Box  style={{direction:'rtl',marginBottom:'-40px',marginRight:'10px',padding:'0px 8px'}}>
    <TabList variant="scrollable" scrollButtons="auto" onChange={handleChange} aria-label="lab API tabs example">
      <Tab label="وضعیت ها" value="1" />
      <Tab label="تاریخچه وضعیت دام ها" value="2" />
      
    </TabList>
  </Box>
  <hr style={{marginTop:'37px'}}/>
  <TabPanel value='1'>
  <Hoc flag={'status'} id=''/>
  </TabPanel>
  <TabPanel value='2'>
  <StatusHistory flag='all'/>
  </TabPanel>
  </TabContext>
      </div>
    </div>
  );
}


export default StatusPage